import React, { Fragment } from "react";
import { metaDigitalMarketing } from "../../../../Utilites";
import MetaTagComponent from "../../../common/Meta/MetaTagComponent";
import ServiceDetailSection from "../../../services/ServiceDetailSection";
import {
  BarChart3,
  ChartArea,
  ChartLine,
  HandCoins,
  Target,
  TargetIcon,
  TrendingUp,
  Users,
  Zap,
} from "lucide-react";

const DigitalMarketingService = () => {
  const services = {
    slug: "digital-marketing",
    title: "Digital Marketing",
    description:
      "Unlock the full potential of your business with comprehensive digital marketing strategies that enhance your online presence, drive targeted traffic, and maximize conversions. Our approach combines SEO, SEM, social media, PPC, and content marketing to boost brand awareness and deliver measurable results.",
    shortDescription:
      "Boost your online presence and drive conversions with data-driven digital marketing strategies tailored to your business needs.",
    icon: BarChart3,
    gradient: "from-pink-500 to-red-500",
    features: [
      "SEO & SEM Optimization",
      "Social Media Marketing",
      "Content Marketing Strategy",
      "Email Marketing Campaigns",
      "PPC Advertising",
      "Analytics & Reporting",
    ],
    benefits: [
      "Increased Brand Visibility",
      "Higher Conversion Rates",
      "Better ROI on Marketing Spend",
      "Data-Driven Decision Making",
    ],
    process: [
      "Market Research & Analysis",
      "Strategy Development",
      "Campaign Implementation",
      "Performance Monitoring",
      "Optimization & Scaling",
    ],
    image: "/assets/img/services/details/digital-marketing-service.png",
  };

  const extension = {
    keyFeatures: [
      {
        name: "SEO Optimization",
        description: "Advanced search engine optimization techniques",
        icon: TrendingUp,
      },
      {
        name: "Social Media Marketing",
        description: "Comprehensive social media strategy and management",
        icon: Users,
      },
      {
        name: "Content Strategy",
        description: "Data-driven content creation and distribution",
        icon: Target,
      },
      {
        name: "Analytics & Reporting",
        description: "Real-time performance tracking and insights",
        icon: BarChart3,
      },
      {
        name: "PPC Campaign Management",
        description: "Optimized pay-per-click advertising campaigns",
        icon: Target,
      },
      {
        name: "Email Marketing",
        description: "Automated email sequences and campaigns",
        icon: Zap,
      },
    ],
    benefits: [
      {
        title: "Increased Brand Visibility",
        description: "Boost your online presence across all channels",
        icon: ChartLine,
      },
      {
        title: "Higher Conversion Rates",
        description: "Convert more visitors into customers",
        icon: TargetIcon,
      },
      {
        title: "Better ROI",
        description: "Maximize return on marketing investment",
        icon: HandCoins,
      },
      {
        title: "Data-Driven Insights",
        description: "Make informed decisions with analytics",
        icon: ChartArea,
      },
    ],
    process: [
      {
        step: "Market Research",
        description: "Analyze your market, competitors, and target audience",
        duration: "1-2 weeks",
      },
      {
        step: "Strategy Development",
        description: "Create a comprehensive marketing strategy",
        duration: "1 week",
      },
      {
        step: "Campaign Implementation",
        description: "Execute campaigns across selected channels",
        duration: "2-4 weeks",
      },
      {
        step: "Performance Monitoring",
        description: "Track and analyze campaign performance",
        duration: "Ongoing",
      },
      {
        step: "Optimization & Scaling",
        description: "Refine strategies and scale successful campaigns",
        duration: "Ongoing",
      },
    ],
    techStack: [
      { name: "Google Analytics", icon: BarChart3, category: "Analytics" },
      { name: "Google Ads", icon: Target, category: "Advertising" },
      { name: "Facebook Ads", icon: Users, category: "Social Media" },
      { name: "HubSpot", icon: Zap, category: "CRM" },
      { name: "Mailchimp", icon: Zap, category: "Email Marketing" },
      { name: "SEMrush", icon: TrendingUp, category: "SEO Tools" },
    ],
  };
  return (
    <Fragment>
      <MetaTagComponent metaDetails={metaDigitalMarketing} />
      <ServiceDetailSection service={services} extension={extension} />
    </Fragment>
  );
};

export default DigitalMarketingService;
